import { APP_INITIALIZER, Provider } from '@angular/core';
import { AuthService } from '@y42/auth';
import { UserService } from '@y42/user';

export const appInitializer = (authService: AuthService, userService: UserService) => async (): Promise<void> => {
  console.debug('[APP_INITIALIZER]: starting');

  if (window.location.pathname.includes('/password/reset')) {
    // TODO: Gabi redirect request to auth app
  } else {
    await authService.initSignInFlow();

    await userService.storeActiveUser();

    authService.startTrackingSession();
  }

  console.debug('[APP_INITIALIZER]: finished');
};

export const APP_INITIALIZER_PROVIDER: Provider = {
  provide: APP_INITIALIZER,
  multi: true,
  useFactory: appInitializer,
  deps: [AuthService, UserService],
};
